import { Box, Button, Skeleton } from "@mui/material";
import { AppIconsCartFilled } from "../AppIcons";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "../../../explorer/hooks/useTranslation";
import { BomItemDetails } from "../../../explorer/types/SpareParts/BomItemDetails";
import ServiceProvider from "../../configuration/ServiceProvider";
import { BasketItemDTO } from "../../../explorer/types/Basket/BasketItems";
import { useBasket } from "../../hook/useBasket";
import { useReduxState } from "../../../explorer/redux/hooks";
import { Machine } from "../../../explorer/types/SpareParts";
import { reduxStoreConfig } from "../../configuration/reduxStoreConfig";
import DrawerPartDetailsBaskets from "../PartDetails/DrawerPart/DrawerPartDetailsBaskets";
import { Basket } from "../../../explorer/types";
import { ContainerTextCart } from "../PartDetails/PartDetails/PartDetails.style";
import { useApiError } from "../../hook/useApiError";
import { useApiNotification } from "../../hook/useApiNotification";
import CommonDialog from "../CommonDialog/CommonDialog";
import AddBasketItemsWarning from "../Basket/AddBasketItemsWarning";
import { useApiWarning } from "../../hook/useApiWarning";

type TMassiveAddButton = {
    rows: BomItemDetails[];
};

const MassiveAddButton: FC<TMassiveAddButton> = (props) => {
    const { rows } = props;

    const [open, setOpen] = useState<boolean>(false);

    const { t } = useTranslation();

    const handleOpenDialog = () => {
        setOpen(true);
    };

    const handleCloseDialog = () => {
        setOpen(false);
    };
    const [error, setError] = useApiError();
    const [notification, setNotification] = useApiNotification();
    const [warning, setWarning] = useApiWarning();
    

    const currentBasket = useBasket().currentBasket;
    const [selectedBasket, setSelectedBasket] = useState<Basket>(currentBasket);

    const [currentMachine] = useReduxState<Machine>(
        reduxStoreConfig.sparePartsCurrentMachine
    );

    useEffect(() => {
        setSelectedBasket(currentBasket);
    }, [currentBasket]);

    const AddMassive = () => {
        var items: BasketItemDTO[] = [];
        rows.filter(row => row.showBasket).map((row: BomItemDetails) => {
            items.push({
                code: row.replacementCode || row.code,
                qty: 1,
                basketId: selectedBasket.id,
                navContext: `${currentMachine.serialNumber}`,
                manufacturerCompanyCode: row.manufacturer,
                replacedCode: row.replacementCode === null ? undefined : row.code,
            });
        });

        ServiceProvider.Basket.AddBasketItems(items)
            .catch((errors) => {
                if (errors)
                    setError(
                        errors.map((e: { errorCode: string | undefined }) =>
                            t(`basket.items.${e.errorCode}`)
                        )
                    );
                else setError(t("basket.genericError"));
            })
            .then((result) => {
                if (result && result.warning === true) {
                    setWarning(<AddBasketItemsWarning apiResult={result}></AddBasketItemsWarning>);    
                } else {
                    setNotification(t("common.basket.itemsAddedSelectedBasket"));
                }
                setNotification(t("common.basket.itemsAdded"));
            });

        handleCloseDialog();
    };

    return (
        <Box>
            {rows !== undefined ? (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        margin: "10px 0",
                    }}
                >
                    <Button
                        sx={{ gap: "10px !important" }}
                        color="primary"
                        onClick={handleOpenDialog}
                        variant="outlined"
                    >
                        <AppIconsCartFilled />
                        {t("common.spareparts.massiveAdd")}
                    </Button>

                    {/* <Dialog open={open} onClose={handleCloseDialog}>
                        <DialogTitle>
                            <Box
                                display={"flex"}
                                sx={{ alignItems: "center", gap: "10px" }}
                            >
                                {t("common.spareparts.addMassiveItemTitle")}
                            </Box>
                        </DialogTitle>
                        <DialogContent sx={{ paddingTop: "20px !important" }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                }}
                            >
                                <Typography variant="body1">
                                    {t(
                                        "common.spareparts.addMassiveItemContent"
                                    )}
                                </Typography>
                            </Box>
                        </DialogContent>
                        <Divider />
                    </Dialog> */}

                    <CommonDialog
                        open={open}
                        dialogTitleLabel={
                            "common.spareparts.addMassiveItemTitle"
                        }
                        dialogContentLabel={
                            "common.spareparts.addMassiveItemContent"
                        }
                        closeDialog={handleCloseDialog}
                        confirmButton={AddMassive}
                    >
                        <ContainerTextCart>
                            <span>{t("common.spareparts.selectedBasket")}</span>
                            <span>{selectedBasket.name}</span>
                            <DrawerPartDetailsBaskets
                                setSelectedBasket={setSelectedBasket}
                            />
                        </ContainerTextCart>
                    </CommonDialog>
                </Box>
            ) : (
                <Skeleton />
            )}
        </Box>
    );
};
export default MassiveAddButton;
